import {BaseComponentLifecycleEventHandler} from "./base-component-lifecycle-event-handler";
import {ComponentController} from "../controllers/component-controller";

export class ContainerRefreshHandler extends BaseComponentLifecycleEventHandler {
  lastLocationStateUpdateTime: Number;

  onInitialized(controller: ComponentController) {
    super.onInitialized(controller);

    this.lastLocationStateUpdateTime = this.historyManager.locationState?.updateTime;
  }

  onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, prevProps);

    const shouldResetState = this.historyManager.locationState?.resetState;
    const hasUpdate = this.historyManager.locationState?.updateTime !== this.lastLocationStateUpdateTime;

    if (hasUpdate && shouldResetState) {
      this.refresh(this.controller)
    }
  }

  refresh(controller: ComponentController) {
    controller.store.remount();
    controller.domUtils.scrollToTop();

    this.lastLocationStateUpdateTime = this.historyManager.locationState?.updateTime;
  }
}
